// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type CertificationDetailOverviewTableQueryVariables = PrivateSchemaTypes.Exact<{
  mainAnalyticsFilter: PrivateSchemaTypes.AnalyticsFilterWithGroups;
  certificationsOverviewFilter: PrivateSchemaTypes.AnalyticsCertificationDetailFilter;
}>;


export type CertificationDetailOverviewTableQuery = (
  { __typename?: 'Query' }
  & { analytics: (
    { __typename?: 'AnalyticsModel' }
    & { certifications: (
      { __typename?: 'AnalyticsCertificationsModel' }
      & { certificationEnrolments?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CertificationEnrolmentsOverview' }
        & Pick<PrivateSchemaTypes.CertificationEnrolmentsOverview, 'count'>
        & { items: Array<(
          { __typename?: 'CertificationEnrolmentModelAsAdmin' }
          & Pick<PrivateSchemaTypes.CertificationEnrolmentModelAsAdmin, 'id' | 'progress' | 'started_at' | 'completed_at' | 'expires_at' | 'deleted_at' | 'status' | 'shared_at' | 'target_date'>
          & { certification: (
            { __typename?: 'CertificationModelAsAdmin' }
            & Pick<PrivateSchemaTypes.CertificationModelAsAdmin, 'id' | 'name' | 'deleted_at'>
          ), user: (
            { __typename?: 'UserModel' }
            & Pick<PrivateSchemaTypes.UserModel, 'id' | 'email' | 'display_name' | 'first_name' | 'last_name' | 'phone_number' | 'account_name' | 'image_url' | 'userIdentity' | 'organisation_role' | 'created_at' | 'creation_method' | 'is_active' | 'last_activity_at' | 'timezone' | 'locale' | 'employee_id' | 'position' | 'area' | 'location' | 'department' | 'custom_1' | 'custom_2' | 'custom_3' | 'start_at' | 'deleted_at' | 'is_archived'>
            & { manager?: PrivateSchemaTypes.Maybe<(
              { __typename?: 'UserModel' }
              & Pick<PrivateSchemaTypes.UserModel, 'id' | 'display_name' | 'email'>
            )>, createdBy?: PrivateSchemaTypes.Maybe<(
              { __typename?: 'UserModel' }
              & Pick<PrivateSchemaTypes.UserModel, 'display_name'>
            )> }
          ) }
        )> }
      )> }
    ) }
  ) }
);

export type CertificationBatchArchiveEnrolmentsQueryVariables = PrivateSchemaTypes.Exact<{
  certificationId: PrivateSchemaTypes.Scalars['PositiveInt'];
  enrolmentIds: Array<PrivateSchemaTypes.Scalars['PositiveInt']> | PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type CertificationBatchArchiveEnrolmentsQuery = (
  { __typename?: 'Query' }
  & { certification?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'CertificationModelAsAdmin' }
    & Pick<PrivateSchemaTypes.CertificationModelAsAdmin, 'batchArchiveEnrolments'>
  )> }
);


export const CertificationDetailOverviewTableDocument = gql`
    query CertificationDetailOverviewTable($mainAnalyticsFilter: AnalyticsFilterWithGroups!, $certificationsOverviewFilter: AnalyticsCertificationDetailFilter!) {
  analytics(filter: $mainAnalyticsFilter) {
    certifications {
      certificationEnrolments(overviewTableFilter: $certificationsOverviewFilter) {
        items {
          id
          progress
          started_at
          completed_at
          expires_at
          deleted_at
          status
          shared_at
          target_date
          certification {
            id
            name
            deleted_at
          }
          user {
            id
            email
            display_name
            first_name
            last_name
            phone_number
            account_name
            image_url
            userIdentity
            organisation_role
            created_at
            creation_method
            is_active
            last_activity_at
            timezone
            locale
            employee_id
            position
            area
            location
            department
            custom_1
            custom_2
            custom_3
            start_at
            deleted_at
            is_archived
            manager {
              id
              display_name
              email
            }
            createdBy {
              display_name
            }
          }
        }
        count
      }
    }
  }
}
    `;

/**
 * __useCertificationDetailOverviewTableQuery__
 *
 * To run a query within a React component, call `useCertificationDetailOverviewTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useCertificationDetailOverviewTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCertificationDetailOverviewTableQuery({
 *   variables: {
 *      mainAnalyticsFilter: // value for 'mainAnalyticsFilter'
 *      certificationsOverviewFilter: // value for 'certificationsOverviewFilter'
 *   },
 * });
 */
export function useCertificationDetailOverviewTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CertificationDetailOverviewTableQuery, CertificationDetailOverviewTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CertificationDetailOverviewTableQuery, CertificationDetailOverviewTableQueryVariables>(CertificationDetailOverviewTableDocument, options);
      }
export function useCertificationDetailOverviewTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CertificationDetailOverviewTableQuery, CertificationDetailOverviewTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CertificationDetailOverviewTableQuery, CertificationDetailOverviewTableQueryVariables>(CertificationDetailOverviewTableDocument, options);
        }
export type CertificationDetailOverviewTableQueryHookResult = ReturnType<typeof useCertificationDetailOverviewTableQuery>;
export type CertificationDetailOverviewTableLazyQueryHookResult = ReturnType<typeof useCertificationDetailOverviewTableLazyQuery>;
export type CertificationDetailOverviewTableQueryResult = Apollo.QueryResult<CertificationDetailOverviewTableQuery, CertificationDetailOverviewTableQueryVariables>;
export const CertificationBatchArchiveEnrolmentsDocument = gql`
    query CertificationBatchArchiveEnrolments($certificationId: PositiveInt!, $enrolmentIds: [PositiveInt!]!) {
  certification(id: $certificationId) {
    batchArchiveEnrolments(enrolmentIds: $enrolmentIds)
  }
}
    `;

/**
 * __useCertificationBatchArchiveEnrolmentsQuery__
 *
 * To run a query within a React component, call `useCertificationBatchArchiveEnrolmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCertificationBatchArchiveEnrolmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCertificationBatchArchiveEnrolmentsQuery({
 *   variables: {
 *      certificationId: // value for 'certificationId'
 *      enrolmentIds: // value for 'enrolmentIds'
 *   },
 * });
 */
export function useCertificationBatchArchiveEnrolmentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CertificationBatchArchiveEnrolmentsQuery, CertificationBatchArchiveEnrolmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CertificationBatchArchiveEnrolmentsQuery, CertificationBatchArchiveEnrolmentsQueryVariables>(CertificationBatchArchiveEnrolmentsDocument, options);
      }
export function useCertificationBatchArchiveEnrolmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CertificationBatchArchiveEnrolmentsQuery, CertificationBatchArchiveEnrolmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CertificationBatchArchiveEnrolmentsQuery, CertificationBatchArchiveEnrolmentsQueryVariables>(CertificationBatchArchiveEnrolmentsDocument, options);
        }
export type CertificationBatchArchiveEnrolmentsQueryHookResult = ReturnType<typeof useCertificationBatchArchiveEnrolmentsQuery>;
export type CertificationBatchArchiveEnrolmentsLazyQueryHookResult = ReturnType<typeof useCertificationBatchArchiveEnrolmentsLazyQuery>;
export type CertificationBatchArchiveEnrolmentsQueryResult = Apollo.QueryResult<CertificationBatchArchiveEnrolmentsQuery, CertificationBatchArchiveEnrolmentsQueryVariables>;